import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const HexagonCheckIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width={18}
      height={16}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M9.0002 16C8.51199 16 8.02377 15.8719 7.58855 15.6153L3.19336 13.0261C2.34838 12.5278 1.82344 11.6098 1.82344 10.6292V5.37026C1.82344 4.39008 2.34838 3.47165 3.19295 2.97384L7.58855 0.384626C8.45941 -0.128209 9.54141 -0.128209 10.4119 0.384626L13.6908 2.31621C13.9291 2.45641 14.0084 2.76353 13.8682 3.00179C13.728 3.24006 13.4208 3.31934 13.1826 3.17914L9.90361 1.24756C9.34613 0.919159 8.65386 0.919159 8.0968 1.24756L3.70161 3.83677C3.16082 4.15515 2.82491 4.74309 2.82491 5.37026V10.6292C2.82491 11.2564 3.16082 11.8443 3.70161 12.1627L8.0968 14.7519C8.65386 15.0803 9.34654 15.0803 9.90361 14.7519L14.2988 12.1627C14.8342 11.8473 15.1697 11.266 15.1747 10.6459V10.6213L15.1751 5.18875C15.1751 4.91209 15.3992 4.68801 15.6758 4.68801C15.9525 4.68801 16.1765 4.91209 16.1765 5.18875V10.6292C16.1765 10.6422 16.1765 10.6547 16.1757 10.6672C16.1632 11.6319 15.6399 12.5349 14.807 13.0256L10.4114 15.6149C9.97622 15.8715 9.488 15.9996 8.99979 15.9996L9.0002 16Z"
        fill="currentColor"
      />
      <path
        d="M15.6053 2.36004C15.4676 2.38257 14.401 3.35232 14.401 3.35232C12.4073 4.98096 10.5049 6.71475 8.73565 8.58248C8.63592 8.68764 8.49279 8.88793 8.39515 8.96847C8.37262 8.98724 8.36886 9.00101 8.33256 8.98849C7.83767 8.09218 7.25932 7.2159 6.62506 6.4068C6.44145 6.1727 5.86895 5.43537 5.6432 5.32939C5.11952 5.08319 4.59542 5.6678 4.83994 6.17145C4.98265 6.46563 5.43122 6.94926 5.64362 7.2593C6.26536 8.16854 6.81742 9.17544 7.30731 10.1606C7.50259 10.5529 7.7225 11.1855 7.94407 11.5218C8.07927 11.7267 8.37136 11.7792 8.58042 11.6549C9.02607 11.122 9.40997 10.5324 9.82933 9.97577C11.1655 8.20109 12.6706 6.48232 14.2195 4.88791C14.7599 4.33126 15.4968 3.73038 15.9767 3.16079C16.0167 3.11322 16.0835 3.04145 16.1056 2.98679C16.245 2.63669 15.9833 2.2987 15.6053 2.36004Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HexagonCheckIcon;
